<div class="list_container mt-4">
  <div class="mt-4 ms-3 me-3 mb-4">
    <div>
      <label class="field-name">
        {{ stepInput.name }}
        <span
          *ngIf="stepInput.type == 'ads_txt'"
          matTooltip="The ads.txt file helps you verify that you're buying ad inventory from authorized sellers. It reduces fraud by confirming which exchanges are approved to sell a publisher’s inventory."
          matTooltipClass="tooltip-class"
          class="material-icons tool-tip ms-1"
        >
          error
        </span>
      </label>
    </div>
    <div>
      <mat-form-field
        class="no-padding search-input-shadow list-search"
        appearance="outline"
      >
        <input
          matInput
          class="placeholders"
          (keyup)="searchList($event)"
          placeholder="Search {{ stepInput.name }}"
          #input
        />
        <mat-icon matSuffix class="material-icons search_icon">
          search
        </mat-icon>
      </mat-form-field>
    </div>

    <div class="deals_container mt-3">
      <div class="deals_sub_container">
        <div>
          <table
            mat-table
            #listSort="matSort"
            [dataSource]="dataSourceList"
            matSort
          >
            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef>
                <div
                  *ngIf="allListItems.length > 0 && !stepInput.isDlvMod"
                  class="table-checkboxes"
                >
                  <ng-container
                    *ngIf="
                      !stepInput.isBulkEdit || bulkEditAction != 'remove_all'
                    "
                  >
                    <label class="checkbox-container mt-1">
                      <input type="checkbox" (click)="addAllListItems()" />
                      <span class="checkboxmark"></span>
                    </label>
                  </ng-container>
                </div>
              </th>
              <td mat-cell *matCellDef="let row">
                <ng-container
                  *ngIf="
                    !stepInput.isBulkEdit || bulkEditAction != 'remove_all'
                  "
                >
                  <label class="checkbox-container">
                    <input type="checkbox" (click)="addListItem(row)" />
                    <span class="checkboxmark"></span>
                  </label>
                </ng-container>
              </td>
            </ng-container>
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> ID </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.id }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Name </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span
                  [ngClass]="{
                    table_value_name: true,
                    cursor_pointer: stepInput.type == 'ads_txt'
                  }"
                  [matTooltip]="
                    stepInput.type == 'ads_txt' ? row.description : ''
                  "
                  >{{ row.name }}</span
                >
              </td>
            </ng-container>
            <ng-container matColumnDef="level">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Level </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.level }}</span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumnLevel"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnLevel"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data available</td>
            </tr>
          </table>
          <mat-paginator
            #listPaginator
            [pageSizeOptions]="[10, 15, 25, 100]"
            (page)="handlePageEvent($event)"
            [length]="listPageLength"
          ></mat-paginator>
        </div>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div class="deals_sub_container">
        <div class="mb-2" *ngIf="stepInput.isBulkEdit">
          <div class="field-name">Operation:</div>
          <mat-radio-group
            [(ngModel)]="bulkEditAction"
            (change)="checkOperation(); proceed()"
          >
            <mat-radio-button
              class="ms-2"
              *ngFor="let item of trgtOperations"
              [value]="item.value"
              [matTooltip]="item.toolTip"
            >
              {{ item.label }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="flex_column fix-height">
          <div class="select-content-list-title">
            <div *ngIf="!stepInput.isDlvMod && !isMulAction && stepInput.type !== 'interstitial_type'">
              <span
                [ngClass]="{
                  'mt-5': true,
                  table_header_name: true,
                  'remove-capitalize': stepInput.type == 'ads_txt'
                }"
              >
                {{ stepInput.name }} Action:
              </span>

              <span class="ms-3">
                <span
                  matTooltip="Select to INCLUDE in targeting"
                  (click)="
                    !stepInput.isBulkEdit ||
                    (this.stepInput.isBulkEdit && this.stepInput.targetsEmpty)
                      ? updateAction('include')
                      : ''
                  "
                  [ngClass]="{
                    'material-icons': true,
                    'include-icon-selected': selectedAction == 'include',
                    'include-icon': selectedAction == 'exclude'
                  }"
                >
                  check
                </span>
                <span
                  matTooltip="Select to EXCLUDE in targeting"
                  (click)="
                    !stepInput.isBulkEdit ||
                    (this.stepInput.isBulkEdit && this.stepInput.targetsEmpty)
                      ? updateAction('exclude')
                      : ''
                  "
                  [ngClass]="{
                    'material-icons': true,
                    'exclude-icon-selected': selectedAction == 'exclude',
                    'ms-2': true,
                    'exclude-icon': selectedAction == 'include'
                  }"
                >
                  block
                </span>
              </span>
            </div>
          </div>

          <mat-list>
            <mat-list-item>
              <div class="flex_row_space_between">
                <div class="flex_row">
                  <label
                    class="checkbox-container mt-2"
                    *ngIf="!stepInput.isDlvMod"
                  >
                    <input
                      type="checkbox"
                      [checked]="selectedLists.length > 0"
                      (click)="removeAllSelectedLists()"
                    />
                    <span class="checkboxmark"></span>
                  </label>
                  <span class="field-name mt-1 ms-2">Name</span>
                </div>
                <ng-container
                  *ngIf="
                    !staticDBItems.has(stepInput.type) &&
                    !constListing.has(stepInput.key) &&
                    !staticListing.has(stepInput.type)
                  "
                >
                  <div class="flex_row ms-4">
                    <span class="field-name mt-1 ms-5">Level</span>
                  </div>
                  <div class="flex_row">
                    <span class="field-name mt-1 me-2">ID</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="isMulAction">
                  <div class="flex_row">
                    <span
                      class="material-icons ml-3"
                      style="cursor: pointer; color: gray"
                      (click)="removeAllSelectedLists()"
                    >
                      cancel
                    </span>
                  </div>
                </ng-container>
              </div>
            </mat-list-item>
          </mat-list>
          <div class="selected-list-content">
            <div class="list_container_content mt-1">
              <mat-list>
                <mat-list-item *ngFor="let list of selectedLists; let l = last">
                  <div class="flex_row_space_between">
                    <div class="flex_row">
                      <ng-container *ngIf="isMulAction; else singleAction">
                        <span
                          matTooltip="Select to INCLUDE in targeting"
                          [ngClass]="{
                            'material-icons': true,
                            'include-icon':
                              list[this.actionMapping[this.stepInput.type]] ===
                              'exclude',
                            'include-icon-selected':
                              list[this.actionMapping[this.stepInput.type]] ===
                              'include'
                          }"
                          (click)="
                            list[this.actionMapping[this.stepInput.type]] =
                              'include'
                          "
                        >
                          check
                        </span>

                        <span
                          matTooltip="Select to EXCLUDE from targeting"
                          [ngClass]="{
                            'material-icons': true,
                            'exclude-icon':
                              list[this.actionMapping[this.stepInput.type]] ===
                              'include',
                            'exclude-icon-selected':
                              list[this.actionMapping[this.stepInput.type]] ===
                              'exclude'
                          }"
                          (click)="
                            list[this.actionMapping[this.stepInput.type]] =
                              'exclude'
                          "
                        >
                          block
                        </span>
                      </ng-container>
                      <ng-template #singleAction>
                        <label class="checkbox-container mt-1">
                          <input
                            type="checkbox"
                            checked
                            (click)="removeSelectedItem(list)"
                          />
                          <span class="checkboxmark"></span>
                        </label>
                      </ng-template>
                      <span class="mt-1 ms-2 alignNameText">
                        {{ list.name }}
                      </span>
                    </div>
                    <ng-container
                      *ngIf="
                        !staticDBItems.has(stepInput.type) &&
                        !constListing.has(stepInput.key) && !staticListing.has(stepInput.type)
                      "
                    >
                      <div class="flex_row">
                        <span class="mt-1 me-5">{{
                          list.level.split("_").join(" ") | titlecase
                        }}</span>
                      </div>
                      <div class="flex_row">
                        <span class="mt-1 me-2">{{ list.id }}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="isMulAction">
                      <div class="flex_row">
                        <span
                          class="material-icons ml-3"
                          style="cursor: pointer; color: gray"
                          (click)="removeSelectedItem(list)"
                        >
                          cancel
                        </span>
                      </div>
                    </ng-container>
                  </div>
                  <mat-divider *ngIf="!l"></mat-divider>
                </mat-list-item>
              </mat-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
